/** API route map: URLS.Controller.PayrollProcessingSchedule */
export const PayrollProcessingSchedule = {
      Name: 'PayrollProcessingSchedule/',
      GetAll: 'getall',
      GetAllUsedCode: 'get-all-used-code',
      Add: 'add',
      Update: 'update',
      Delete: 'delete',
};
